/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnalysisResultDto,
} from '../models/index';
import {
    AnalysisResultDtoFromJSON,
    AnalysisResultDtoToJSON,
} from '../models/index';

export interface GetMeasurementAnalysisResultsRequest {
    measurementGroupId: string;
}

/**
 * 
 */
export class MeasurementDataApi extends runtime.BaseAPI {

    /**
     */
    async getMeasurementAnalysisResultsRaw(requestParameters: GetMeasurementAnalysisResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnalysisResultDto>> {
        if (requestParameters.measurementGroupId === null || requestParameters.measurementGroupId === undefined) {
            throw new runtime.RequiredError('measurementGroupId','Required parameter requestParameters.measurementGroupId was null or undefined when calling getMeasurementAnalysisResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/measurement-data/profiles-analysis-result/{measurementGroupId}`.replace(`{${"measurementGroupId"}}`, encodeURIComponent(String(requestParameters.measurementGroupId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => AnalysisResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async getMeasurementAnalysisResults(requestParameters: GetMeasurementAnalysisResultsRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getMeasurementAnalysisResultsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<AnalysisResultDto>(response, errorHandlers);
    }

}
